import type { Order } from "@graphql/generated/types";
import type { IAdyenPaymentMethodStrategy } from "@interfaces/payment-method/AdyenDefaultPaymentMethodStrategy";
import type { PaymentValues } from "@lib/utils/checkoutHelper";

export class AdyenResolver {
    private strategies: Map<string, IAdyenPaymentMethodStrategy>;

    constructor(strategies: Map<string, IAdyenPaymentMethodStrategy>) {
        this.strategies = strategies;
    }

    resolve(order: Order): PaymentValues {
        if (!order?.paymentInfo?.payments) return null;

        const isAdvancedFlow = process.env.NEXT_PUBLIC_PAYMENT_ADVANCED_FLOW === "true";
        if (isAdvancedFlow) {
            const advancedFlowStrategyResult = this.strategies.get("advancedFlow")?.resolve(order);

            if (advancedFlowStrategyResult.paymentSystem) {
                return advancedFlowStrategyResult;
            }
        } else {
            const defaultStrategyResult = this.strategies.get("default")?.resolve(order);

            if (defaultStrategyResult.paymentSystem) {
                return defaultStrategyResult;
            }
        }

        const deferredPaymentStrategyResult = this.strategies
            .get("deferredPayment")
            ?.resolve(order);

        if (deferredPaymentStrategyResult.paymentSystem) {
            return deferredPaymentStrategyResult;
        }

        //return initial values
        return {
            paymentSystem: null,
            paymentSystemIcon: null,
            paymentReference: null,
            paymentDateOfExpiry: null,
        };
    }
}
